import { render } from "./ChangePmConfirmation.vue?vue&type=template&id=5f5cde74&scoped=true"
import script from "./ChangePmConfirmation.vue?vue&type=script&lang=js"
export * from "./ChangePmConfirmation.vue?vue&type=script&lang=js"

import "./ChangePmConfirmation.vue?vue&type=style&index=0&id=5f5cde74&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5cde74"]])

export default __exports__